var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Notice",class:{pointer: _vm.hideOnClick},on:{"click":_vm.click}},[(_vm.hasSpinner)?_c('spinner',{staticClass:"Notice-spinner"}):_vm._e(),(_vm.icon)?_c('i',{staticClass:"Icon Icon--s Notice-icon"},[_vm._v(" "+_vm._s(_vm.icon)+" ")]):_vm._e(),_c('p',{staticClass:"Notice-message"},[_vm._v(" "+_vm._s(_vm.message)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }